// 热门主题配置文件
// 如需修改、添加或删除主题，只需编辑此文件即可

const popularTopics = [
    {
        title: "Orders & Transportation",
        description: "Track your order, shipping times, delivery options, and returns.",
        iconClass: "fa-truck",
        imageUrl: "https://cdn.shopify.com/s/files/1/0780/8906/0577/files/1_e11fc1f4-3dda-4e32-8e5d-fe31defa1e64.jpg?v=1762150762",
        imageAlt: "Order processing and shipping",
        linkUrl: "https://poongia.com/pages/orders-transportation",
        searchTerms: "orders shipping track tracking delivery options returns"
    },
    {
        title: "Payment Process",
        description: "Payment methods, invoicing, subscriptions, and refund policies.",
        iconClass: "fa-credit-card",
        imageUrl: "https://cdn.shopify.com/s/files/1/0780/8906/0577/files/2_d0369b32-c57f-41b4-993b-b0fc956b9026.jpg?v=1762150763",
        imageAlt: "Payment methods and billing",
        linkUrl: "https://poongia.com/pages/payment-process",
        searchTerms: "payments billing credit card invoicing subscriptions refund policies"
    },
    {
        title: "Product User Guide",
        description: "Product details, usage guides, care instructions, and specifications.",
        iconClass: "fa-info-circle",
        imageUrl: "https://cdn.shopify.com/s/files/1/0780/8906/0577/files/3_ec9efaf5-cdff-494d-8385-61111630454a.jpg?v=1762150763",
        imageAlt: "Product information and guides",
        linkUrl: "https://poongia.com/pages/product-user-guide",
        searchTerms: "products guides details usage care instructions specifications"
    },
    {
        title: "Account Management lssues",
        description: "Creating an account, updating details, password recovery, and preferences.",
        iconClass: "fa-user-circle",
        imageUrl: "https://cdn.shopify.com/s/files/1/0780/8906/0577/files/4_78a27c54-bcd2-4259-90fa-43015420a702.jpg?v=1762150762",
        imageAlt: "Customer account management",
        linkUrl: "https://poongia.com/pages/account-management-lssues",
        searchTerms: "account management create updating details password recovery preferences"
    },
    {
        title: "Troubleshooting",
        description: "Common issues, error messages, and step-by-step solutions.",
        iconClass: "fa-wrench",
        imageUrl: "https://cdn.shopify.com/s/files/1/0780/8906/0577/files/troubleshooting.jpg?v=1762741205",
        imageAlt: "Troubleshooting common issues",
        linkUrl: "https://poongia.com/pages/troubleshooting",
        searchTerms: "troubleshooting issues error messages solutions problems"
    },
    {
        title: "Contact Customer Service",
        description: "How to get in touch with our customer service team for further help.",
        iconClass: "fa-comments",
        imageUrl: "https://cdn.shopify.com/s/files/1/0780/8906/0577/files/6_0d2afa21-e3ce-4d1b-9ca8-427f84ef3e85.jpg?v=1762150763",
        imageAlt: "Contacting customer support",
        linkUrl: "https://poongia.com/pages/contact",
        searchTerms: "contact support customer service team help"
    }
];
